import { render, staticRenderFns } from "./verifDetails.vue?vue&type=template&id=3ed42717&scoped=true"
import script from "./verifDetails.vue?vue&type=script&lang=js"
export * from "./verifDetails.vue?vue&type=script&lang=js"
import style0 from "./verifDetails.vue?vue&type=style&index=0&id=3ed42717&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed42717",
  null
  
)

export default component.exports